import { useClient } from './useClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ServiceConfigRequest } from '@hud/rules-dtos/api-rules.dtos';
import { RULE_ID } from './useRule';

export default function useAddServiceConfigMutation(ruleId: string) {
  const { client } = useClient('detection');
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ServiceConfigRequest) =>
      client.post(`/rules/${ruleId}/service-configs`, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RULE_ID, ruleId] });
    },
  });
}
